import { useTranslation } from 'react-i18next'

import { EyeSlashIcon } from '@phosphor-icons/react'

import { Button, Text } from '@reveni-io/reveni-ui'

import { hiddenBlocksBannerCopies } from './constants'
import * as Styles from './styles'

const HiddenBlocksBanner = ({ hiddenBlockCount, onShowHiddenBlocks }) => {
  const { t } = useTranslation()

  const copy = hiddenBlockCount === 1 ? hiddenBlocksBannerCopies.single : hiddenBlocksBannerCopies.multiple

  return (
    <Styles.Container>
      <EyeSlashIcon size={24} />
      <Text type="bodyMRegular">{t(copy.message, { count: hiddenBlockCount })}</Text>
      <Button variant="text" size="s" onClick={onShowHiddenBlocks}>
        {t(copy.action)}
      </Button>
    </Styles.Container>
  )
}

export default HiddenBlocksBanner
